/* ==========================================================================
   LALTERNATIVA STYLE - MEGA MENU SUI DISPOSITIVI TOUCH (iPad e simili)
   Caricato da snippets/las-global-inline.liquid.

   PROBLEMA (visto su iPad, 19 set 2026)
   Toccando COLLEZIONI / ABBIGLIAMENTO / CALZATURE il mega menu faceva un
   lampo scuro e poi il tablet veniva portato sulla collezione padre
   (Collezioni -> /collections/cerimonia, Abbigliamento -> tutto
   l'abbigliamento, e cosi' via). Il menu non si apriva mai.

   PERCHE'
   Il tema ha l'impostazione "apri i menu a tendina al passaggio del mouse"
   attiva (classe .show-dropdown-menu-on-hover sull'header). Con quella
   impostazione assets/header.js apre il mega menu solo su mouseenter, e la
   voce principale resta un <a href> vero e proprio.
   Su un touch screen il passaggio del mouse non esiste: il tocco genera un
   mouseenter finto - che fa partire l'apertura, ed e' il lampo scuro, cioe'
   il velo .f-header__dropdown-backdrop - e subito dopo un click sul link,
   che porta via dalla pagina prima che la tendina si veda.
   Su computer con il mouse non succede nulla di tutto questo, per questo il
   problema si vede solo da tablet.

   COSA FA QUESTO FILE
   Solo quando il tocco e' davvero un tocco (pointerType "touch" o "pen"):
     primo tocco sulla voce  -> non naviga, apre il mega menu
     secondo tocco sulla stessa voce -> naviga, come prima
     tocco altrove o scroll  -> chiude
   Con il mouse non interviene: il comportamento a passaggio del mouse resta
   identico a prima.

   PERCHE' pointerType E NON UNA MEDIA QUERY
   Una regola tipo (hover: none) classifica il dispositivo una volta per
   tutte e sbaglia sui portatili con schermo touch e sull'iPad con mouse o
   trackpad collegati. Guardando il tipo di puntatore del singolo evento si
   decide tocco per tocco: lo stesso iPad col Magic Keyboard continua a
   funzionare al passaggio del puntatore e a rispondere al dito.

   SE UN DOMANI SI VUOLE CHE LA VOCE PRINCIPALE NON SIA PIU' CLICCABILE
   Dentro il mega menu c'e' gia' la riga "Tutto l'Abbigliamento" / "Tutte le
   Calzature". Basta togliere il ramo "gia' aperta -> lascia navigare" e
   chiamare sempre preventDefault.
   ========================================================================== */
(function () {
  var CLASSE_APERTA = 'f-menu__item-active';
  var ATTESA_MINIMA = 350; /* ms fra apertura e tocco che naviga */
  var tocco = false;
  var apertaDaNoi = null;
  var apertaAlle = 0;

  /* Ogni pressione dice di che natura e'. Va in fase di cattura perche' il
     tema ferma la propagazione di alcuni eventi sul menu. */
  document.addEventListener(
    'pointerdown',
    function (e) {
      tocco = e.pointerType === 'touch' || e.pointerType === 'pen';
    },
    true
  );

  /* Browser senza Pointer Events (molto vecchi): si ripiega sulla media
     query, meno precisa ma meglio di niente. */
  if (!window.PointerEvent) {
    try {
      tocco = window.matchMedia('(hover: none)').matches;
    } catch (err) {
      tocco = false;
    }
  }

  function header() {
    return document.querySelector('.site-header');
  }

  function chiudiTutte() {
    var aperte = document.querySelectorAll('.f-site-nav__item.' + CLASSE_APERTA);
    if (!aperte.length) return;
    for (var i = 0; i < aperte.length; i++) {
      aperte[i].classList.remove(CLASSE_APERTA);
    }
    var h = header();
    if (h && typeof h.handleMegaItemDeactive === 'function') {
      h.handleMegaItemDeactive();
    }
    apertaDaNoi = null;
  }

  function apri(li) {
    chiudiTutte();
    var h = header();
    var tendina = li.querySelector('.f-site-nav__dropdown');
    /* handleMegaItemActive misura la tendina e da' l'altezza al velo dietro
       l'header: senza, il velo resta alto 0 e l'effetto e' sporco. */
    if (h && tendina && typeof h.handleMegaItemActive === 'function') {
      h.handleMegaItemActive(tendina);
    }
    li.classList.add(CLASSE_APERTA);
    apertaDaNoi = li;
    apertaAlle = Date.now();
  }

  document.addEventListener(
    'click',
    function (e) {
      var bersaglio = e.target;
      if (!bersaglio || !bersaglio.closest) return;

      var link = bersaglio.closest('.f-site-nav__link');

      /* Tocco fuori dal menu principale: se qualcosa era aperto lo chiudo.
         Dentro la tendina no: li' i link devono funzionare. */
      if (!link) {
        if (!bersaglio.closest('.f-site-nav__dropdown')) chiudiTutte();
        return;
      }

      var li = link.closest('.f-site-nav__item--has-child');
      if (!li) {
        /* voce senza tendina (Novita', Best Seller): chiudo e lascio andare */
        chiudiTutte();
        return;
      }

      if (!tocco) return; /* mouse: comanda il tema, come prima */

      /* Secondo tocco sulla voce che ho aperto io: lascio navigare.
         NON mi baso sulla sola classe: anche il tema la mette, per conto suo,
         a partire dal mouseenter finto del tocco, e se arrivasse prima del
         click leggerei "gia' aperta" al PRIMO tocco e il difetto resterebbe.
         Il quarto di secondo scarso serve invece contro il click fantasma che
         iOS spara subito dopo il tocco. */
      if (
        li === apertaDaNoi &&
        li.classList.contains(CLASSE_APERTA) &&
        Date.now() - apertaAlle > ATTESA_MINIMA
      ) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      /* Click fantasma sulla voce appena aperta: fermato e basta, senza
         richiudere e riaprire (azzererebbe il cronometro qui sopra). */
      if (li === apertaDaNoi && li.classList.contains(CLASSE_APERTA)) return;

      apri(li);
    },
    true
  );

  /* Scorrendo la pagina la tendina resterebbe appesa sopra il contenuto.
     Solo dopo un tocco: col mouse la tendina la governa il tema, e chiuderla
     allo scroll la farebbe sparire mentre il puntatore e' ancora sopra. */
  window.addEventListener(
    'scroll',
    function () {
      if (tocco) chiudiTutte();
    },
    { passive: true }
  );
})();
